import { REGISTER_USER, LOGIN, LOGOUT } from "../types";
import { firebase } from "../../../firebase/initFirebase";

import { message } from "antd";

import store from "../../store";
import moment from "moment";

export const RegisterUser = ({ name, email, password, phoneNumber }) => {
  return async (dispatch) => {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((userCredential) => {
        // Signed in
        var user = userCredential.user;
        // console.log(user)
        if (user) {
          var Firestore = firebase.firestore();
          var UseresRef = Firestore.collection("users");
          UseresRef.doc(user.uid)
            .set({
              email: user.email,
              photoURL: user.photoURL,
              tenantId: user.tenantId,
              phoneNumber: phoneNumber,
              name: name,
              code: null,
              role: "none",
              branch: "HQ",
              created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
            })
            .then((doc) => {
              // console.log(doc)
              message.success("Registraion Successful");
              window.location.href = "/";
            })
            .catch((error) => {
              var errorMessage = error.message;
              message.error(errorMessage);
            });
        }
      })
      .catch((error) => {
        // console.log(error);
        var errorCode = error.code;
        var errorMessage = error.message.message ?? error.message;
        message.error("invalid credentials");
      });
  };
};

export const LoginUser = ({ email, password }) => {
  return async (dispatch) => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        // Signed in
        var user = userCredential.user;

        if (user) {
          var Firestore = firebase.firestore();
          var UseresRef = Firestore.collection("users");
          UseresRef.doc(user.uid)
            .get()
            .then((doc) => {
              var userData = doc.data();

              if (userData.role == "none" || userData.role == null) {
                message.warning("Wait For Confirmation");
              } else {
                dispatch({ type: LOGIN, payload: userData });
                message.success("Login Successful");
              }
            })
            .catch((error) => {
              var errorMessage = error.message;
              message.error(errorMessage);
            });
        } // ...
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        message.error(errorMessage);
      });
  };
};

export const LogoutUser = () => {
  return async (dispatch) => {
    dispatch({ type: LOGOUT, payload: null });
    firebase.auth().signOut();
  };
};

export const SendPasswordResetEmail = (email) => {
  return async (dispatch) => {
    return firebase.auth().sendPasswordResetEmail(email);
  };
};
